import { Document, View, Text } from "@react-pdf/renderer";
import type { FC } from "react";
import type { Message } from "@/types/chat";
import type { ReportBlock } from "@/types/blocks";
import { PdfPageWrapper } from "./PdfPageWrapper";
import { PdfBlockRenderer } from "./PdfBlockRenderer";
import { PdfMdText } from "./PdfMdText";
import styles from "./pdfStyles";

interface PdfDocumentProps {
  message: Message;
  chartImages: Map<number, string>;
  logoSrc?: string | null;
}

export const PdfDocumentComponent: FC<PdfDocumentProps> = ({
  message,
  chartImages,
  logoSrc,
}) => {
  const blocks = (message.structured?.blocks as ReportBlock[]) ?? [];
  const hasBlocks = blocks.length > 0;

  return (
    <Document>
      <PdfPageWrapper logoSrc={logoSrc}>
        {message.title && (
          <View wrap={false} minPresenceAhead={80}>
            <View style={styles.promptCard}>
              <Text style={styles.promptText}>{message.title}</Text>
            </View>
            <View style={styles.divider} />
          </View>
        )}

        {hasBlocks ? (
          <PdfBlockRenderer blocks={blocks} chartImages={chartImages} />
        ) : (
          <PdfMdText content={message.content} />
        )}
      </PdfPageWrapper>
    </Document>
  );
};
